"use client";

import React, { useEffect, useRef } from "react";

interface PullquoteBlockProps {
  block: {
    htmlContent?: string;
    [key: string]: any;
  };
  blockStyle?: React.CSSProperties;
  extraClass?: string;
}

const Pullquote: React.FC<PullquoteBlockProps> = ({
  block,
  blockStyle,
  extraClass = "",
}) => {
  const pullquoteContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (pullquoteContainerRef.current) {
      const pullquoteElement =
        pullquoteContainerRef.current.querySelector("blockquote");
      if (pullquoteElement) {
        pullquoteElement.classList.add("pullquote-element");
      }
    }
  }, []);

  if (!block.htmlContent) {
    return (
      <div className={`pullquote-container ${extraClass}`} style={blockStyle}>
        <div className="bg-gray-100 p-4 text-center rounded"></div>
      </div>
    );
  }

  return (
    <div
      ref={pullquoteContainerRef}
      className={`pullquote-container relative ${extraClass}`}
      style={blockStyle}
      dangerouslySetInnerHTML={{ __html: block.htmlContent }}
    />
  );
};

export default Pullquote;
